import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum AccDeliveryPageTabId {
	Curriculum = 1,
	Graduation = 2,
	Awards = 3
}

/**
 * The list of main tab droplist views on this page
 */
export enum AccDeliveryPageViewId {
	AllEvents = 1,
	Sessions = 2,
	Topics = 3,
	TopicSpecialists = 4,
	SurveysBySesssion = 5,
	SurveysByTopic = 6,
	SurveysBySpecialist = 7,
	Enrollments = 8,
	ProgressBySection = 9,
	FinalPresentation = 10,
	Graduation = 11,
	Awards = 12,
}


@Injectable({ providedIn: 'root' })
export class AccDeliveryService extends PageTabsLayoutPageService<AccDeliveryPageTabId, AccDeliveryPageViewId> {

	private static readonly _viewDroplistItems: DroplistItem<never, AccDeliveryPageViewId>[] = [
		{
			uniqueId: AccDeliveryPageViewId.AllEvents,
			iconContext: {
				iconClass: 'fa-calendar-days',
				iconStyle: 'fa-solid',
				text: 'All Events',
				hideText: 'never',
			},
			groupName: 'Events',
			customSort: '1-coh-1'
		},
		{
			uniqueId: AccDeliveryPageViewId.Sessions,
			iconContext: {
				iconClass: 'fa-screen-users',
				iconStyle: 'fa-solid',
				text: 'Sessions',
				hideText: 'never',
			},
			groupName: 'Curriculum',
			customSort: '2-coh-1'
		},
		{
			uniqueId: AccDeliveryPageViewId.Topics,
			iconContext: {
				iconClass: 'fa-square-t',
				iconStyle: 'fa-solid',
				text: 'Topics',
				hideText: 'never',
			},
			groupName: 'Curriculum',
			customSort: '2-coh-2'
		},
		{
			uniqueId: AccDeliveryPageViewId.TopicSpecialists,
			iconContext: {
				iconClass: 'fa-person',
				iconStyle: 'fa-solid',
				text: 'Topic Specialists',
				hideText: 'never',
			},
			groupName: 'Curriculum',
			customSort: '2-coh-3'
		},
		{
			uniqueId: AccDeliveryPageViewId.SurveysBySesssion,
			iconContext: {
				iconClass: 'fa-flip-horizontal fa-message-smile',
				iconStyle: 'fa-solid',
				text: 'Surveys By Session',
				hideText: 'never',
			},
			groupName: 'Curriculum',
			customSort: '2-coh-4'
		},
		{
			uniqueId: AccDeliveryPageViewId.SurveysByTopic,
			iconContext: {
				iconClass: 'fa-flip-horizontal fa-message-smile',
				iconStyle: 'fa-solid',
				text: 'Surveys By Topic',
				hideText: 'never',
			},
			groupName: 'Curriculum',
			customSort: '2-coh-5'
		},
		{
			uniqueId: AccDeliveryPageViewId.SurveysBySpecialist,
			iconContext: {
				iconClass: 'fa-flip-horizontal fa-message-smile',
				iconStyle: 'fa-solid',
				text: 'Surveys By Specialist',
				hideText: 'never',
			},
			groupName: 'Curriculum',
			customSort: '2-coh-6'
		},
		{
			uniqueId: AccDeliveryPageViewId.Enrollments,
			iconContext: {
				iconClass: 'fa-book-user',
				iconStyle: 'fa-solid',
				text: 'Enrollments',
				hideText: 'never',
			},
			groupName: 'Course Progress',
			customSort: '3-coh-1'
		},
		{
			uniqueId: AccDeliveryPageViewId.ProgressBySection,
			iconContext: {
				iconClass: 'fa-bars-progress',
				iconStyle: 'fa-solid',
				text: 'Progress By Section',
				hideText: 'never',
			},
			groupName: 'Course Progress',
			customSort: '3-coh-2'
		},
		{
			uniqueId: AccDeliveryPageViewId.FinalPresentation,
			iconContext: {
				iconClass: 'fa-calendar',
				iconStyle: 'fa-solid',
				text: 'Final Presentation',
				hideText: 'never',
			},
			groupName: 'Evaluation',
			customSort: '4-coh-1'
		},
		{
			uniqueId: AccDeliveryPageViewId.Graduation,
			iconContext: {
				iconClass: 'fa-graduation-cap',
				iconStyle: 'fa-solid',
				text: 'Graduation',
				hideText: 'never',
			},
			groupName: 'Evaluation',
			customSort: '4-coh-2'
		},
		{
			uniqueId: AccDeliveryPageViewId.Awards,
			iconContext: {
				iconClass: 'fa-award',
				iconStyle: 'fa-solid',
				text: 'Awards',
				hideText: 'never',
			},
			groupName: 'Evaluation',
			customSort: '4-coh-3'
		},
	];

	constructor() {
		super(AccDeliveryService._viewDroplistItems, AccDeliveryService.name, AccDeliveryPageTabId.Curriculum, AccDeliveryPageViewId.AllEvents);
	}

	public get viewId() {
		return AccDeliveryPageViewId;
	}
}
